module.exports = __webpack_public_path__ + "assets/img/btn-detail-c5ff8287.png";